import React from 'react';
import Helmet from 'react-helmet';
import SEO from '../components/SEO';
import Layout from '../components/Layout';
import RelatedLinks from '../components/RelatedLinks';

const srOnly = {
  position: 'absolute',
  width: '1px',
  height: '1px',
  padding: 0,
  margin: '-1px',
  overflow: 'hidden',
  clip: 'rect(0, 0, 0, 0)',
  whiteSpace: 'nowrap',
  border: 0
};

const Supplier = () => {
  const pageTitle = '供应商入驻 - 魔鬼鱼订货平台';
  const pageDescription = '宠物用品供应商入驻魔鬼鱼订货平台，3万+B端用户，50000+SKU，覆盖全国宠物门店。品牌扶持计划，首页banner/搜索置顶/推荐位等曝光资源，1V1运营支持。';

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '宠物用品供应商如何入驻魔鬼鱼订货平台？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '供应商资质合规即可入驻，提供营业执照、品牌授权等资质材料，缩短上架周期。适配中小品牌与新品试水，轻资产运营。入驻后直达3万+B端客户，覆盖全国宠物门店、医院、连锁店等。'
        }
      },
      {
        '@type': 'Question',
        name: '供应商入驻魔鬼鱼平台需要什么资质？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '需提供营业执照、品牌授权书或经销资质、产品质检报告等合规材料。资质审核通过后即可上架商品，开始接收B端门店订单。'
        }
      },
      {
        '@type': 'Question',
        name: '魔鬼鱼平台有多少B端用户和SKU？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '魔鬼鱼订货平台已拥有3万+优质B端用户，商城超50000+SKU，全国数百家知名供应商、品牌方已入驻，覆盖宠物主粮、零食、洗护、药品等全品类。'
        }
      },
      {
        '@type': 'Question',
        name: '供应商入驻后有哪些曝光资源？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '平台提供首页banner、品牌专区、每日秒杀、搜索置顶、推荐位等多种曝光资源。另有新品/爆款/尾货专区，新品快速获得曝光，打造平台爆品。临期专区+特价机制帮助降低库存成本。'
        }
      },
      {
        '@type': 'Question',
        name: '平台提供哪些供应商运营支持？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '平台提供专属1V1品宣支持、新品推广、复购数据诊断服务。提供门店复购率、热销SKU分析，指导产品优化与渠道策略，陪跑助品牌落地。'
        }
      },
      {
        '@type': 'Question',
        name: '供应商入驻平台收费吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '魔鬼鱼订货平台供应商入驻详情请扫码咨询专属运营顾问，平台提供品牌扶持计划，适配不同规模供应商的入驻需求。'
        }
      }
    ]
  };

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: '魔鬼鱼订货平台供应商入驻',
    description: '魔鬼鱼订货平台供应商入驻，3万+B端用户，50000+SKU，品牌扶持计划',
    provider: {
      '@type': 'Organization',
      name: '魔鬼鱼订货平台'
    },
    serviceType: '供应商入驻',
    areaServed: {
      '@type': 'Country',
      name: 'CN'
    },
    audience: {
      '@type': 'Audience',
      audienceType: '宠物用品供应商、品牌方'
    },
    offers: {
      '@type': 'Offer',
      description: '平台提供多种入驻方案，具体费用请咨询运营顾问'
    }
  };

  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '供应商入驻',
    description: '魔鬼鱼订货平台供应商入驻，3万+B端用户，50000+SKU，品牌扶持计划'
  };

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: '首页',
        item: 'https://www.mantas.cn'
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: '供应商入驻',
        item: 'https://www.mantas.cn/supplier'
      }
    ]
  };

  return (
    <Layout bodyClass="page-supplier">
      <SEO title={pageTitle} description={pageDescription} path="/supplier" />
      <Helmet>
        <meta
          name="keywords"
          content="供应商入驻, 魔鬼鱼订货平台, 宠物用品供应商, B2B宠物订货, 品牌入驻, 宠物行业, 宠物供应链"
        />
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
        <script type="application/ld+json">
          {JSON.stringify(faqSchema)}
        </script>
        <script type="application/ld+json">
          {JSON.stringify(breadcrumbSchema)}
        </script>
        <script type="application/ld+json">
          {JSON.stringify(webPageSchema)}
        </script>
      </Helmet>

      <section className="supplier-page">
        <h1 style={srOnly}>供应商入驻 — 魔鬼鱼订货平台</h1>
        <section className="supplier-intro">
          <p>
            【魔鬼鱼订货平台】作为业内数一数二的宠物用品一站式订货平台。
            已拥有3万+优质B端用户，商城超SKU50000+，全国数百家知名供应商、品牌方已入驻。同时也欢迎新供应商了解入驻。入驻即可享受品牌扶持计划。
          </p>
        </section>

        <section className="supplier-advantages">
          <article className="supplier-advantage-card">
            <div className="advantage-header">
              <span className="advantage-dot"></span>
              <h3 className="advantage-title">入驻简单，精准触达</h3>
              <span className="advantage-number">01</span>
            </div>
            <div className="advantage-body">
              <p>
                （新供应商）资质合规即可入驻，缩短上架周期。轻资产运营，适配中小品牌与新品试水。
                直达3万+B端客户，覆盖全国宠物门店，医院，连锁店等，精准匹配宠物用品采购人。订货节流量加持，每月固定大促，集中引爆订单。
              </p>
            </div>
          </article>

          <article className="supplier-advantage-card">
            <div className="advantage-header">
              <span className="advantage-dot"></span>
              <h3 className="advantage-title">平台顶级曝光资源</h3>
              <span className="advantage-number">02</span>
            </div>
            <div className="advantage-body">
              <p>
                首页banner/品牌专区/每日秒杀：曝光给进入平台的每一个客户，获得平台黄金流量。
                搜索置顶/推荐位：优先展示，提升商品点击率与下单转化率。
                新品/爆款/尾货专区：新品快速获得曝光，打造平台爆品。提供临期专区+ 特价机制，帮助降低库存成本。
              </p>
            </div>
          </article>

          <article className="supplier-advantage-card">
            <div className="advantage-header">
              <span className="advantage-dot"></span>
              <h3 className="advantage-title">1V1 私域运营与数据赋能</h3>
              <span className="advantage-number">03</span>
            </div>
            <div className="advantage-body">
              <p>
                专属品宣支持：平台私域1V1品宣支持，新品推广。
                复购数据诊断：提供门店复购率、热销 SKU 分析，指导产品优化与渠道策略，陪跑助品牌落地。
              </p>
            </div>
          </article>
        </section>

        <section className="supplier-faq-section" aria-label="供应商入驻常见问题">
          <div className="supplier-faq-container">
            <h2 className="supplier-faq-title">供应商入驻常见问题</h2>
            <div className="supplier-faq-list">
              {faqSchema.mainEntity.map((faq, index) => (
                <article key={index} className="supplier-faq-item">
                  <h3 className="supplier-faq-question">{faq.name}</h3>
                  <div className="supplier-faq-answer">
                    <p>{faq.acceptedAnswer.text}</p>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section className="supplier-qrcode-section">
          <img
            className="qrcode-image"
            src="/images/supplier-qrcode.png"
            alt="魔鬼鱼订货平台供应商入驻二维码 — 扫码咨询"
            loading="lazy"
          />
          <div className="qrcode-text">扫码详细咨询了解</div>
        </section>

        {/* 站内互链（GEO 延伸阅读） */}
        <RelatedLinks
          title="延伸阅读"
          links={[
            { label: '注册指南', to: '/registration-guide/' },
            { label: '帮助中心', to: '/help' },
          ]}
        />
      </section>
    </Layout>
  );
};

export default Supplier;